import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetStandPerRegistersInputDto, StandPerRegisterCreateDto, StandPerRegisterDto, StandPerRegisterExcelDownloadDto, StandPerRegisterUpdateDto } from '../dtos/stand-per-register/models';

@Injectable({
  providedIn: 'root',
})
export class StandPerRegisterService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: StandPerRegisterCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandPerRegisterDto>({
      method: 'POST',
      url: '/api/planning/standPerRegisters',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/standPerRegisters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/standPerRegisters',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandPerRegisterDto>({
      method: 'GET',
      url: `/api/planning/standPerRegisters/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCensusArea = (registerId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: `/api/planning/standPerRegisters/census-area/${registerId}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/standPerRegisters/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetStandPerRegistersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<StandPerRegisterDto>>({
      method: 'GET',
      url: '/api/planning/standPerRegisters',
      params: { standId: input.standId, standName: input.standName, registerId: input.registerId, registerName: input.registerName, standRegisterArea: input.standRegisterArea, standRegisterAreaFrom: input.standRegisterAreaFrom, standRegisterAreaTo: input.standRegisterAreaTo, standAreaPercentage: input.standAreaPercentage, standAreaPercentageFrom: input.standAreaPercentageFrom, standAreaPercentageTo: input.standAreaPercentageTo, registerAreaPercentage: input.registerAreaPercentage, registerAreaPercentageFrom: input.registerAreaPercentageFrom, registerAreaPercentageTo: input.registerAreaPercentageTo, isMainRegister: input.isMainRegister, isLastRegister: input.isLastRegister, isStandPerRegisterAvailableInGis: input.isStandPerRegisterAvailableInGis, propertyId: input.propertyId, propertyName: input.propertyName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: StandPerRegisterExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/standPerRegisters/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, standId: input.standId, standName: input.standName, registerId: input.registerId, registerName: input.registerName, standRegisterArea: input.standRegisterArea, standRegisterAreaFrom: input.standRegisterAreaFrom, standRegisterAreaTo: input.standRegisterAreaTo, standAreaPercentage: input.standAreaPercentage, standAreaPercentageFrom: input.standAreaPercentageFrom, standAreaPercentageTo: input.standAreaPercentageTo, registerAreaPercentage: input.registerAreaPercentage, registerAreaPercentageFrom: input.registerAreaPercentageFrom, registerAreaPercentageTo: input.registerAreaPercentageTo, isMainRegister: input.isMainRegister, isLastRegister: input.isLastRegister, isStandPerRegisterAvailableInGis: input.isStandPerRegisterAvailableInGis, propertyId: input.propertyId, propertyName: input.propertyName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandPerRegisterDto[]>({
      method: 'GET',
      url: '/api/planning/standPerRegisters/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: StandPerRegisterUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, StandPerRegisterDto>({
      method: 'PUT',
      url: `/api/planning/standPerRegisters/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}